import React, {ReactElement, Suspense} from 'react';

export default function withSuspense(Component, props = {}): () => ReactElement {
  return function withSuspenseWrapper(): ReactElement {
    return (
      <Suspense fallback={null}>
        <Component {...props} />
      </Suspense>
    );
  };
}
